import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const timezoneStore = defineStore('timezoneStore', () => {
  const getInitialOffset = (): number => {
    try {
      const stored = localStorage.getItem('timezoneOffsetMinutes')
      if (stored) {
        const num = Number(stored)
        if (Number.isFinite(num)) {
          return num
        }
      }
    } catch (error) {
      console.error('Error reading timezone from localStorage:', error)
    }
    return 0
  }

  const offsetMinutes = ref<number>(getInitialOffset())

  const getOffsetMinutes = computed(() => offsetMinutes.value)

  const setTimezoneOffset = (minutes: number) => {
    offsetMinutes.value = minutes
    try {
      if (minutes === 0) {
        localStorage.removeItem('timezoneOffsetMinutes')
      } else {
        localStorage.setItem('timezoneOffsetMinutes', String(minutes))
      }
    } catch (error) {
      console.error('Error saving timezone to localStorage:', error)
    }
  }

  const initializeTimezone = () => {
    offsetMinutes.value = getInitialOffset()
  }

  return {
    getOffsetMinutes,
    setTimezoneOffset,
    initializeTimezone,
  }
})
